import React from 'react';
import leftWingPink from '../assets/images/leftwing.png';
import rightWingPink from '../assets/images/rightwing.png';
import bodyPink from '../assets/images/body.png';

import leftWingWhite from '../assets/images/leftwing-white.png';
import rightWingWhite from '../assets/images/rightwing-white.png';
import bodyWhite from '../assets/images/body.png';

import '../assets/Butterfly.css';

const Butterfly = ({
  direction = 'right',
  animationDelay = 0,
  size = 1,
  startX = Math.random() * 100, // % of screen width
  startY = Math.random() * 80,  // % of screen height
  colorType // optional: "pink" or "white"
}) => {
  // Randomize color if not provided
  const color = colorType || (Math.random() > 0.5 ? 'pink' : 'white');

  const leftWing = color === 'pink' ? leftWingPink : leftWingWhite;
  const rightWing = color === 'pink' ? rightWingPink : rightWingWhite;
  const body = color === 'pink' ? bodyPink : bodyWhite;

  const pathClass = direction === 'left' ? 'butterfly-left' : 'butterfly-right';

  return (
    <div
      className={`butterfly-container ${pathClass}`}
      style={{
        animationDelay: `${animationDelay}s`,
        top: `${startY}vh`,
        left: `${startX}vw`,
        transform: `scale(${size})`,
      }}
    >
      <div className="butterfly">
        <img src={leftWing} alt="Left Wing" className="wing left-wing" />
        <img src={body} alt="Body" className="body" />
        <img src={rightWing} alt="Right Wing" className="wing right-wing" />
      </div>
    </div>
  );
};

export default Butterfly;
